var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLeftChevronLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "chevron-lrg",
  d: "M5.05 16.797c-.24.27-.63.27-.87 0a.76.76 0 0 1 0-.981L12 7l7.82 8.816c.24.27.24.71 0 .98a.566.566 0 0 1-.87 0L12 8.963z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "#81848F",
  fillRule: "nonzero",
  transform: "rotate(-90 12 12)",
  xlinkHref: "#chevron-lrg"
})));
export default SvgIconLeftChevronLarge;